import { render, staticRenderFns } from "./braceletForm.vue?vue&type=template&id=54cb921a&scoped=true&"
import script from "./braceletForm.vue?vue&type=script&lang=js&"
export * from "./braceletForm.vue?vue&type=script&lang=js&"
import style0 from "./braceletForm.vue?vue&type=style&index=0&id=54cb921a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb921a",
  null
  
)

export default component.exports